import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import './../../shared/rxjs-operators';
import { LogService, ApiService, CacheService, AppContext, Port } from './../../shared';

@Injectable()
export class SchedulesSearchService {
  ports: Observable<any>;
  locations: Observable<any>;
  public originAutoOn = false;
  public originLoaderOn = false;
  public originPortLoader: boolean = false;
  public originLocationLoader: boolean = false;
  public originPortNoResult = true;
  public originLocationNoResult = true;

  public destinationAutoOn = false;
  public destinationLoaderOn = false;
  public destinationPortLoader: boolean = false;
  public destinationLocationLoader: boolean = false;
  public destinationLocationNoResult = true;
  public destinationPortNoResult = true;

  constructor(private logger: LogService, private api: ApiService, private cache: CacheService, public app: AppContext) {
  }

  startPortSearch(input) {
    if (input === 'origin') {
      this.originAutoOn = true;
      this.originLoaderOn = true;
      this.originPortLoader = true;
      this.originPortNoResult = true;
    } else {
      this.destinationAutoOn = true;
      this.destinationLoaderOn = true;
      this.destinationPortLoader = true;
      this.destinationPortNoResult = true;
    }
  }

  getPorts(input: string, term: string): Observable<any> {
    this.startPortSearch(input);
    // let cache = this.cache.get('ports' + term);
    let promise = this.api.getApiClient().then(client => this.callGetPorts(client, term, input));
    let server = Observable.fromPromise(promise);
    this.ports = server;
    // this.ports = Observable.concat(cache, server);
    // this.cache.updateCache('ports' + term, this.ports);

    return this.ports;
  }

  callGetPorts(apigClient: any, term: string, input: string): Promise<any> {
    this.logger.log('schedules-search.service', 'callGetPorts', term);
    return new Promise((resolve, reject) => {
      if (term.trim().length === 0) {
        resolve(null);
        return;
      }
      let params = {};
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: {
          search: term,
          in_schedules: 1
        }
      };
      try {
        apigClient.portsGet(params, '', additionalParams)
          .then((result) => {
            this.logger.log('schedules-search.service', 'ports resolve', result);
            let formatted = this.formatPorts(result.data, input);
            resolve(formatted);
          }).catch((err) => {
            this.api.handleError(err);
            this.endPortSearch(true, input);
          });
      } catch (ex) {
        this.logger.log('schedules-search.service', 'catch', ex);
        return reject(ex);
      }
    });
  }

  endPortSearch(isNull: boolean, input: string) {
    if (input === 'origin') {
      this.originPortLoader = false;
      if (!this.originPortLoader && !this.originLocationLoader) {
        this.originLoaderOn = false;
      }
      if (isNull) {
        this.originPortNoResult = true;
      } else {
        this.originPortNoResult = false;
      }
    } else {
      this.destinationPortLoader = false;
      if (!this.destinationPortLoader && !this.destinationLocationLoader) {
        this.destinationLoaderOn = false;
      }
      if (isNull) {
        this.destinationPortNoResult = true;
      } else {
        this.destinationPortNoResult = false;
      }
    }
  }

  formatPorts(data: any, input: string): Array<any> {
    this.logger.log('schedules-search.service', 'formatPorts', input);
    try {
      this.endPortSearch(false, input);
      let formatted = new Array<Port>();
      for (let current = 0; current < data.items.length; current++) {
        formatted.push(new Port(data.items[current]));
      }
      return formatted;
    } catch (ex) {
      this.endPortSearch(true, input);
      return null;
    }
  }

  startLocationSearch(input: string) {
    if (input === 'origin') {
      this.originAutoOn = true;
      this.originLoaderOn = true;
      this.originLocationLoader = true;
      this.originLocationNoResult = true;
    } else {
      this.destinationAutoOn = true;
      this.destinationLoaderOn = true;
      this.destinationLocationLoader = true;
      this.destinationLocationNoResult = true;
    }
  }

  getLocations(input: string, term: string): Observable<any> {
    this.startLocationSearch(input);

    let promise = this.api.getApiClient().then(client => this.callGetLocations(client, term, input));
    let server = Observable.fromPromise(promise);
    this.locations = server;

    return this.locations;
  }

  private callGetLocations(apigClient: any, term: string, input: string): Promise<any> {
    this.logger.log('schedules-search.service', 'callGetLocations', term);
    return new Promise((resolve, reject) => {
      if (term.trim().length === 0) {
        resolve(null);
        return;
      }
      let params = {};
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: {
          search: term
        }
      };
      try {
        apigClient.locationsGet(params, '', additionalParams)
          .then((result) => {
            this.logger.log('schedules-search.service', 'locations resolve', result);
            let formatted = this.formatLocations(result.data, input);
            resolve(formatted);
          }).catch((err) => {
            this.api.handleError(err);
            this.endLocationSearch(true, input);
          });
      } catch (ex) {
        this.logger.log('schedules-search.service', 'catch', ex);
        return reject(ex);
      }
    });
  }

  formatLocations(data: any, input: string): Array<any> {
    this.logger.log('schedules-search.service', 'formatLocations', input);
    try {
      this.endLocationSearch(false, input);
      let formatted = data.items;
      for (let current = 0; current < formatted.length; current++) {
        this.formatLocation(formatted[current]);
      }
      return formatted;
    } catch (ex) {
      this.endLocationSearch(true, input);
      return null;
    }
  }

  formatLocation(item: any): any {
    if (item.type === 'country') {
      item.image = '../img/flags/' + item.id + '.svg';
    } else if (item.type === 'region') {
      item.image = '../img/flags/' + item.value.country.id + '.svg';
    } else {
      item.image = '';
    }
  }

  endLocationSearch(isNull: boolean, input: string) {
    if (input === 'origin') {
      this.originLocationLoader = false;
      if (!this.originPortLoader && !this.originLocationLoader) {
        this.originLoaderOn = false;
      }
      this.originLocationNoResult = isNull;
    } else {
      this.destinationLocationLoader = false;
      if (!this.destinationPortLoader && !this.destinationLocationLoader) {
        this.destinationLoaderOn = false;
      }
      this.destinationLocationNoResult = isNull;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/search/schedules-search/schedules-search.service.ts